import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// import pay from '@/view/wxPay/index'
// import chargeMoney from '@/view/wxPay/chargeMoney'
// import scanQrcPay from '@/view/wxPay/scanQrcPay'

Vue.use(Router)

Router.prototype.goBack = function() {
  this.isBack = true
  window.history.go(-1)
}
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// store.state 保存滚动位置
store.state.common = {
  scrollPos: []
}
export default new Router({
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition && to.meta.keepAlive) {
      let scrollTop = store.state.common.scrollPos[to.name] || 0
      if (scrollTop) {
        // 对scroll元素进行设置
        setTimeout(() => {
          let documentElem = document.querySelector('.scrollYContainer')
          if (documentElem) {
            documentElem.scrollTop = scrollTop
          }
        }, 0)
      }
    }
  },
  routes: [{
    path: '/',
    name: 'index',
    component: resolve => require(['@/view/index'], resolve),
    meta: {
      title: '首页'
    }
  }, {
    path: '/front',
    name: 'front',
    component: resolve => require(['@/view/wxPay/front'], resolve),
    meta: {
      title: '首页'
    }
  },  {
    path: '/personalInfo',
    name: 'personalInfo',
    component: resolve => require(['@/view/personInfo/personalInfo'], resolve),
    meta: {
      title: '个人中心'
    }
  },{
    path: '/addWxCoupon',
    name: 'addWxCoupon',
    component: resolve => require(['@/view/coupons/addWxCoupon'], resolve),
    meta: {
      title: '领取优惠券'
    }
  }, {
    path: '/couponsAuditList',
    name: 'couponsAuditList',
    component: resolve => require(['@/view/coupons/couponsAuditList'], resolve),
    meta: {
      title: '审批列表'
    }
  }, {
    path: '/auditConfirm',
    name: 'auditConfirm',
    component: resolve => require(['@/view/coupons/auditConfirm'], resolve),
    meta: {
      title: '审批确认'
    }
  }, {
    path: '/chargeMoney',
    name: 'chargeMoney',
    component: resolve => require(['@/view/wxPay/chargeMoney'], resolve),
    meta: {
      title: '付款'
    }
  }, {
    path: '/invoiceHome',
    name: 'invoiceHome',
    component: resolve => require(['@/view/electronicInvoice/invoiceHome'], resolve),
    meta: {
      title: '开票中心',
    }
  }, {
    path: '/invoiceImg',
    name: 'invoiceImg',
    component: resolve => require(['@/view/electronicInvoice/invoiceImg'], resolve),
    meta: {
      title: '电子发票预览'
    }
  }, {
    path: '/testImg',
    name: 'testImg',
    component: resolve => require(['@/view/electronicInvoice/testImg'], resolve),
    meta: {
      title: '图片放大'
    }
  }, {
    path: '/electronicInvoice',
    name: 'electronicInvoice',
    component: resolve => require(['@/view/electronicInvoice/electronicInvoice'], resolve),
    meta: {
      title: '停车发票',
    }
  }, {
    path: '/couponsInvoice',
    name: 'couponsInvoice',
    component: resolve => require(['@/view/electronicInvoice/couponsInvoice'], resolve),
    meta: {
      title: '优惠券发票'
    }
  }, {
    path: '/monthInvoice',
    name: 'monthInvoice',
    component: resolve => require(['@/view/electronicInvoice/monthInvoice'], resolve),
    meta: {
      title: '月卡发票'
    }
  }, {
    path: '/issueInvoice',
    name: 'issueInvoice',
    component: resolve => require(['@/view/electronicInvoice/issueInvoice'], resolve),
    meta: {
      title: '开具电子发票',
    }
  }, {
    path: '/invoiceSuccess',
    name: 'invoiceSuccess',
    component: resolve => require(['@/view/electronicInvoice/invoiceSuccess'], resolve),
    meta: {
      title: '发票申请成功'
    }
  }, {
    path: '/moreInfo',
    name: 'moreInfo',
    component: resolve => require(['@/view/electronicInvoice/moreInfo'], resolve),
    meta: {
      title: '更多内容'
    }
  }, {
    path: '/myInvoice',
    name: 'myInvoice',
    component: resolve => require(['@/view/electronicInvoice/myInvoice'], resolve),
    meta: {
      title: '开票历史',
    }
  }, {
    path: '/invoiceDetail',
    name: 'invoiceDetail',
    component: resolve => require(['@/view/electronicInvoice/invoiceDetail'], resolve),
    meta: {
      title: '发票详情',
    }
  }, {
    path: '/invoiceDetail2',
    name: 'invoiceDetail2',
    component: resolve => require(['@/view/electronicInvoice/invoiceDetail2'], resolve),
    meta: {
      title: '发票详情'
    }
  }, {
    path: '/invoiceParkingRecord',
    name: 'invoiceParkingRecord',
    component: resolve => require(['@/view/electronicInvoice/invoiceParkingRecord'], resolve),
    meta: {
      title: '缴费记录'
    }
  }, {
    path: '/applyInvoiceSuccess',
    name: 'applyInvoiceSuccess',
    component: resolve => require(['@/view/electronicInvoice/applyInvoiceSuccess'], resolve),
    meta: {
      title: '发票申请'
    }
  }, {
    path: '/secondApplyInvoiceSuccess',
    name: 'secondApplyInvoiceSuccess',
    component: resolve => require(['@/view/electronicInvoice/secondApplyInvoiceSuccess'], resolve),
    meta: {
      title: '重开发票'
    }
  }, {
    path: '/againApplyInvoice',
    name: 'againApplyInvoice',
    component: resolve => require(['@/view/electronicInvoice/againApplyInvoice'], resolve),
    meta: {
      title: '重开发票'
    }
  }, {
    path: '/personalInfoPingYun',
    name: 'personalInfoPingYun',
    component: resolve => require(['@/view/personInfo/personalInfoPingYun'], resolve),
    meta: {
      title: '停车缴费'
    }
  }, {
    path: '/personMerchant',
    name: 'personMerchant',
    component: resolve => require(['@/view/personInfo/personMerchant'], resolve),
    meta: {
      title: '商户管理'
    }
  }, {
    path: '/payWarn',
    name: 'payWarn',
    component: resolve => require(['@/view/warn/payWarn'], resolve),
    meta: {
      title: '支付提示'
    }
  }, {
    path: '/scanQrcPay',
    name: 'scanQrcPay',
    component: resolve => require(['@/view/wxPay/scanQrcPay'], resolve),
    meta: {
      title: '扫码支付'
    }
  }, {
    path: '/historyCoupons',
    name: 'historyCoupons',
    component: resolve => require(['@/view/coupons/historyCoupons'], resolve),
    meta: {
      title: '历史卡券'
    }
  }, {
    path: '/merchantsInfo',
    name: 'merchantsInfo',
    component: resolve => require(['@/view/merchants/merchantsInfo'], resolve),
    meta: {
      title: '商户信息'
    }
  }, {
    path: '/personMonth',
    name: 'personMonth',
    component: resolve => require(['@/view/personInfo/personMonth'], resolve),
    meta: {
      title: '月卡办理'
    }
  }, {
    path: '/parkingGuidance',
    name: 'parkingGuidance',
    component: resolve => require(['@/view/parkingGuidance/parkingGuidance'], resolve),
    meta: {
      title: '反向寻车'
    }
  }, {
    path: '/pay',
    name: 'pay',
    component: resolve => require(['@/view/wxPay/index'], resolve),
    meta: {
      title: '停车缴费'
    }
  }, {
    path: '/monthlyChange',
    name: 'monthlyChange',
    component: resolve => require(['@/view/monthChange/monthlyChange'], resolve),
    meta: {
      title: '套餐更改'
    }
  }, {
    path: '/monthChangeDetailPay',
    name: 'monthChangeDetailPay',
    component: resolve => require(['@/view/monthChange/monthChangeDetailPay'], resolve),
    meta: {
      title: '套餐更改'
    }
  }, {
    path: '/couponsInstructions',
    name: 'couponsInstructions',
    component: resolve => require(['@/view/coupons/couponsInstructions'], resolve),
    meta: {
      title: '优惠券使用说明'
    }
  }, {
    path: '/qrcPay',
    name: 'qrcPay',
    component: resolve => require(['@/view/wxpay/qrcPay'], resolve),
    meta: {
      title: '停车缴费'
    }
  }, {
    path: '/unlicensedQroNew',
    name: 'unlicensedQroNew',
    component: resolve => require(['@/view/unlicensedCarOutIn/unlicensedQroNew'], resolve),
    meta: {
      title: '无牌车进场'
    }
  }, {
    path: '/visitorsAppointment',
    name: 'visitorsAppointment',
    component: resolve => require(['@/view/visitorsAppointment/visitorsAppointment'], resolve),
    meta: {
      title: '访客预约'
    }
  }, {
    path: '/secondPay',
    name: 'secondPay',
    component: resolve => require(['@/view/wxPay/secondPay'], resolve),
    meta: {
      title: '确认缴费'
    }
  }, {
    path: '/monthApplication',
    name: 'monthApplication',
    component: resolve => require(['@/view/monthApplication/monthApplication'], resolve),
    meta: {
      title: '月卡申请'
    }
  }, {
    path: '/monthApplicationPay',
    name: 'monthApplicationPay',
    component: resolve => require(['@/view/monthApplication/monthApplicationPay'], resolve),
    meta: {
      title: '月卡缴费'
    }
  }, {
    path: '/monthApplicationDetailPay',
    name: 'monthApplicationDetailPay',
    component: resolve => require(['@/view/monthApplication/monthApplicationDetailPay'], resolve),
    meta: {
      title: '月卡续费'
    }
  }, {
    path: '/billDetail',
    name: 'billDetail',
    component: resolve => require(['@/view/monthApplication/billDetail'], resolve),
    meta: {
      title: '月卡缴费详情'
    }
  }, {
    path: '/chargingStandard',
    name: 'chargingStandard',
    component: resolve => require(['@/view/chargeStandard/chargingStandard'], resolve),
    meta: {
      title: '收费标准'
    }
  }, {
    path: '/monthlyGuarantee',
    name: 'monthlyGuarantee',
    component: resolve => require(['@/view/monthApplication/monthlyGuarantee'], resolve),
    meta: {
      title: '月卡查缴'
    }
  }, {
    path: '/coupons',
    name: 'coupons',
    component: resolve => require(['@/view/coupons/coupons'], resolve),
    meta: {
      title: '领取优惠券'
    }
  }, {
    path: '/unlicensedQro',
    name: 'unlicensedQro',
    component: resolve => require(['@/view/unlicensedCarOutIn/unlicensedQro'], resolve),
    meta: {
      title: '无牌车出场'
    }
  }, {
    path: '/myCoupons',
    name: 'myCoupons',
    component: resolve => require(['@/view/personInfo/myCoupons'], resolve),
    meta: {
      title: '优惠券'
    }
  }, {
    path: '/merchantsCoupons',
    name: 'merchantsCoupons',
    component: resolve => require(['@/view/coupons/merchantsCoupons'], resolve),
    meta: {
      title: '商户卡券'
    }
  }, {
    path: '/applyCoupon',
    name: 'applyCoupon',
    component: resolve => require(['@/view/coupons/applyCoupon'], resolve),
    meta: {
      title: '申请代金券'
    }
  }, {
    path: '/couponsDetail',
    name: 'couponsDetail',
    component: resolve => require(['@/view/personInfo/couponsDetail'], resolve),
    meta: {
      title: '优惠券详情'
    }
  }, {
    path: '/packageDetails',
    name: 'packageDetails',
    component: resolve => require(['@/view/personInfo/packageDetails'], resolve),
    meta: {
      title: '套餐详情'
    }
  }, {
    path: '/parkingRecord',
    name: 'parkingRecord',
    component: resolve => require(['@/view/personInfo/parkingRecord'], resolve),
    meta: {
      title: '停车记录'
    }
  }, {
    path: '/payList',
    name: 'payList',
    component: resolve => require(['@/view/personInfo/payList'], resolve),
    meta: {
      title: '缴费流水'
    }
  }, {
    path: '/merchantsRegister',
    name: 'merchantsRegister',
    component: resolve => require(['@/view/merchants/merchantsRegister'], resolve),
    meta: {
      title: '商户登记'
    }
  }, {
    path: '/payDetail',
    name: 'payDetail',
    component: resolve => require(['@/view/personInfo/payDetail'], resolve),
    meta: {
      title: '缴费详情'
    }
  }, {
    path: '/applyProgress',
    name: 'applyProgress',
    component: resolve => require(['@/view/personInfo/applyProgress'], resolve),
    meta: {
      title: '申请进度'
    }
  }, {
    path: '/accompanyCarMan',
    name: 'accompanyCarMan',
    component: resolve => require(['@/view/personInfo/accompanyCarMan'], resolve),
    meta: {
      title: '随车人员'
    }
  }, {
    path: '/toggleParklot',
    name: 'toggleParklot',
    component: resolve => require(['@/view/personInfo/toggleParklot'], resolve),
    meta: {
      title: '切换车场'
    }
  }, {
    path: '/historyRecord',
    name: 'historyRecord',
    component: resolve => require(['@/view/coupons/historyRecord'], resolve),
    meta: {
      title: '历史审核记录'
    }
  }, {
    path: '/historyRecordDetail',
    name: 'historyRecordDetail',
    component: resolve => require(['@/view/coupons/historyRecordDetail'], resolve),
    meta: {
      title: '审核记录详情'
    }
  }, {
    path: '/myCar',
    name: 'myCar',
    component: resolve => require(['@/view/personInfo/myCar'], resolve),
    meta: {
      title: '我的车辆'
    }
  }, {
    path: '/bindVehicle',
    name: 'bindVehicle',
    component: resolve => require(['@/view/personInfo/bindVehicle'], resolve),
    meta: {
      title: '车辆绑定'
    }
  }, {
    path: '/merchants',
    name: 'merchants',
    component: resolve => require(['@/view/merchants/merchants'], resolve),
    meta: {
      title: '商户绑定授权'
    }
  },{
    path: '/test',
    name: 'test',
    component: resolve => require(['@/view/monthApplication/test'], resolve),
    meta: {
      title: 'test'
    }
  }, {
    path: '/upload',
    name: 'upload',
    component: resolve => require(['@/view/monthApplication/upload'], resolve),
    meta: {
      title: 'upload'
    }
  }, {
    path: '/uploader',
    name: 'uploader',
    component: resolve => require(['@/view/uploader/uploader'], resolve),
    meta: {
      title: 'uploader'
    }
  },{
    path: '/couponsLogin',
    name: 'couponsLogin',
    component: resolve => require(['@/view/coupons/couponsLogin'], resolve),
    meta: {
      title: '商户登录'
    }
  }, {
    path: '/visitorIndex',
    name: 'visitorIndex',
    component: resolve => require(['@/view/visitorManage/visitorIndex'], resolve),
    meta: {
      title: '访客预约'
    }
  }, {
    path: '/visitRegist',
    name: 'visitRegist',
    component: resolve => require(['@/view/visitorManage/visitRegist'], resolve),
    meta: {
      title: '来访登记'
    }
  }, {
    path: '/appointRecord',
    name: 'appointRecord',
    component: resolve => require(['@/view/visitorManage/appointRecord'], resolve),
    meta: {
      title: '预约记录'
    }
  }, {
    path: '/visitAudit',
    name: 'visitAudit',
    component: resolve => require(['@/view/visitorManage/visitAudit'], resolve),
    meta: {
      title: '来访审核'
    }
  }, {
    path: '/auditRecord',
    name: 'auditRecord',
    component: resolve => require(['@/view/visitorManage/auditRecord'], resolve),
    meta: {
      title: '审核记录'
    }
  }, {
    path: '/approveDetail',
    name: 'approveDetail',
    component: resolve => require(['@/view/visitorManage/approveDetail'], resolve),
    meta: {
      title: '已审核详情'
    }
  }, {
    path: '/approveDetails',
    name: 'approveDetails',
    component: resolve => require(['@/view/visitorManage/approveDetail'], resolve),
    meta: {
      title: '待审核详情'
    }
  }, {
    path: '/toApprove',
    name: 'toApprove',
    component: resolve => require(['@/view/visitorManage/approveDetail'], resolve),
    meta: {
      title: '待审核详情'
    }
  }, {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/view/visitorManage/login'], resolve),
    meta: {
      title: '审核登陆'
    }
  },{
    path: '/logins',
    name: 'logins',
    component: resolve => require(['@/view/visitorManage/logins'], resolve),
    meta: {
      title: '审核登陆'
    }
  } ]
})



// WEBPACK FOOTER //
// ./src/router/index.js